import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import logger from "redux-logger";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import buyReducer from "../reducers/buy";
import brandsReducer from "../reducers/brands";
import modelsReducer from "../reducers/models";
import regionsReducer from "../reducers/regions";
import communesReducer from "../reducers/communes";
import branchsReducer from "../reducers/branchs";
import { dev } from "./api";
import citroenReducer from "../reducers/citroen";
import creditReducer from "../reducers/credit";
import omuniReducer from "../reducers/omuni";
import userMiddleware from "./middlewares/userMiddleware";

const middlewares = !dev ? [thunk,userMiddleware] : [thunk, logger, userMiddleware];

const persistBuy = {
    key: 'buy',
    storage: storage,
};

const persistCitroen = {
    key: 'citroen',
    storage: storage,
};

const persistedBuyReducer = persistReducer(persistBuy, buyReducer);
const persistedCitroenReducer = persistReducer(persistCitroen, citroenReducer);

export const store = configureStore({
    reducer: {
        buy: persistedBuyReducer,
        brands: brandsReducer,
        models: modelsReducer,
        regions: regionsReducer,
        communes: communesReducer,
        branchs: branchsReducer,
        citroen: persistedCitroenReducer,
        credit: creditReducer,
        omuni: omuniReducer
    },
    middleware: middlewares,
});

export const persistor = persistStore(store);
export type StoreState = typeof store;
export type PersitorStoreState = typeof persistor;
export type GetState = typeof store.getState;
